// @ts-nocheck
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Modal, Radio, Textarea, Spinner, Box } from 'components';
import { PoHeaderExtract } from './po-header-extract';
import { MR_WITHOUT_STOCK, MR_OTHER_REASON } from 'common/utils/constants';
import {
  ModalCancelButton,
  ModalConfirmButton,
  ModalCloseButton,
  successModalPaperProps
} from './delivery-modal-actions';

const Label = styled.span`
  font-size: ${rem('16px')};
  color: ${props => (props.error ? props.theme.colors.Ma[400] : '#1e293b')};
`;

const LabelTitle = styled.span`
  font-size: ${rem('20px')};
  font-weight: 600;
  color: #1e293b;
`;

const ReasonLabel = styled(FormControlLabel)`
  margin-left: 0;
  margin-right: 0;

  .MuiFormControlLabel-label {
    color: #1e293b;
    font-size: ${rem('16px')};
  }
`;

const Span = styled.span<{ colorState: string, visible: boolean }>`
    top: 542px;
    left: 382px;
    width: 27px;
    height: 14px;
    text-align: left;
    font-size: ${rem('10px')};
    letter-spacing: 0px;
    color: ${props => props.colorState};
    margin-left: 16px;
    maring-top: 4px;
    position: aboslute;
    display: ${props => props.visible ? 'initial' : 'none'}
`;

const ReasonsSection = ({ onChange, selected, reasons = [], error }) => {
  const { t } = useTranslation();

  return (
    <Box marginBottom="17px" marginTop="8px">
      <Label error={error}>{t('summary:modals.change_confirm.reason_section_title')}</Label>
      <RadioGroup value={selected ?? ''} onChange={onChange}>
        <Grid container>
          {(reasons || []).map(reason => (
            <Grid item xs={6} key={reason.value}>
              <ReasonLabel
                value={reason.value}
                control={<Radio color="default" />}
                label={t(reason.label)}
              />
            </Grid>
          ))}
        </Grid>
      </RadioGroup>
    </Box>
  );
};

const CounterCharaterOfTextarea = ({ onChange, limitCharater, colorState, error }) => {
  let counter = onChange.value ? onChange.value.length : 0;
  return (
    <Span colorState={ colorState } visible={ !error }>{counter}/{limitCharater}</Span>
  );
};

const TextAreaSection = ({ onChange, disabled, limitCharater, error }) => {
  const { t } = useTranslation();
  return (
    <Box key="textarea">
      <Textarea
        key="textarea"
        onChange={onChange}
        disabled={disabled}
        error={error}
        fullWidth
        placeholder={t('summary:modals.change_confirm.textarea_placeholder')}
        label={t('summary:modals.change_confirm.textarea_placeholder')}
        multiline
        rows={6}
        rowsMax={6}
        inputProps={{
          maxLength: limitCharater
        }}
        textareaCustom={ true }
      />
    </Box>
  );
};

const useValue = initialValue => {
  const [value, setValue] = useState(initialValue);
  const onChange = event => setValue(event.target.value);
  const clear = () => setValue(initialValue);

  return {
    value,
    onChange,
    clear
  };
};

export function ConfirmChangeModal({ visible, onClose, onConfirm, extract, loading, success, reasons }) {
  const { t } = useTranslation();
  const comment = useValue('');
  const reason = useValue('');
  const [error, setError] = useState(false);

  const moderationReasons = (reasons || []).map(reasonItem => ({
    label: 'summary:modals.change_confirm.reasons.' + reasonItem.name,
    value: String(reasonItem.id)
  }));

  const clearState = () => {
    reason.clear();
    comment.clear();
    setError(false);
  };

  const onClickChange = () => {
    if (!reason.value) {
      setError(true);
      return;
    }

    if (
      parseInt(reason.value, 10) === MR_OTHER_REASON
      && (!comment.value || comment.value.trim() === '')
    ) {
      setError(true);
      return;
    }

    const payload = {
      comment: comment.value,
      reason: parseInt(reason.value, 10)
    };
    clearState();
    onConfirm(payload);
  };

  const onClickClose = () => {
    clearState();
    onClose();
  };

  const getStatusEdit = () => {
    if (error) {
      return '#FF3030';
    }

    if (!reason.value || parseInt(reason.value, 10) === MR_WITHOUT_STOCK) {
      return '#D1D1D1';
    }

    if (parseInt(reason.value, 10) === MR_OTHER_REASON && !comment.value) {
      return '#ACACAC';
    }

    return '#646464';
  };

  useEffect(() => {
    setError(false);
  }, [comment.value, reason.value]);

  return (
    <Modal
      LoadingComponent={<Spinner label={t('summary:modals.change_confirm.loading_message')} />}
      maxWidth={success ? 'md' : 'lg'}
      onClose={onClickClose}
      loading={loading}
      open={visible}
      fullWidth
      PaperProps={success ? successModalPaperProps : undefined}
    >
      <Modal.Title>
        {success ? (
          <LabelTitle>{t('summary:modals.change_confirm.success.title')}</LabelTitle>
        ) : (
          <>{t('summary:modals.change_confirm.title')}</>
        )}
      </Modal.Title>

      <Modal.Content>
        {success ? (
          <Label>{t('summary:modals.change_confirm.success.message', { po: extract[0].value })}</Label>
        ) : (
          <>
            {' '}
            <PoHeaderExtract extract={extract} />

            <ReasonsSection
              onChange={reason.onChange}
              selected={reason.value}
              error={error && !reason.value}
              reasons={moderationReasons}
            />

            <TextAreaSection
              onChange={comment.onChange}
              disabled={parseInt(reason.value, 10) !== MR_OTHER_REASON}
              limitCharater={160}
              error={error && parseInt(reason.value, 10) === MR_OTHER_REASON}
            />

            <CounterCharaterOfTextarea
              onChange={comment}
              limitCharater={160}
              colorState={getStatusEdit()}
              error={error}
            />

            {error && parseInt(reason.value, 10) !== MR_OTHER_REASON && (
              <Span colorState={getStatusEdit()} visible={!reason.value}>
                {t('summary:modals.change_confirm.error.empty_reason')}
              </Span>
            )}
            {error && (
              <Span
                colorState={getStatusEdit()}
                visible={
                  parseInt(reason.value, 10) === MR_OTHER_REASON &&
                  (!comment.value || comment.value.trim() === '')
                }
              >
                {t('summary:modals.change_confirm.error.empty_comment')}
              </Span>
            )}
          </>
        )}
      </Modal.Content>

      <Modal.Actions>
        {success ? (
          <ModalCloseButton colorName={{}} onClick={onClose}>
            {t('summary:modals.close_button')}
          </ModalCloseButton>
        ) : (
          <>
            <ModalCancelButton colorName={{}} onClick={onClickClose}>
              {t('summary:modals.cancel_button')}
            </ModalCancelButton>
            <ModalConfirmButton colorName={{}} onClick={onClickChange}>
              {t('summary:modals.change_confirm.button')}
            </ModalConfirmButton>
          </>
        )}
      </Modal.Actions>
    </Modal>
  );
};